<template>
    <a-config-provider :locale="zh_CN">
    <div id="app">
        <router-view />
    </div>
    </a-config-provider>
</template>

<script>
    import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
    export default {
        name: 'App',
        data() {
            return {
              zh_CN
          }
      },
      mounted(){
        //document.getElementById('app').style.display = 'block';
        //document.getElementById('appLoading').style.display = 'none';
      }
}
</script>

<style>
html{
  height: 100%;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*color: #2c3e50;*/
    height:100%;
}
.com-item{
    border:1px solid #DCDFE6;
    box-shadow: 0 1px 4px rgba(0,21,41,.08);
    border-radius: 6px;
    padding: 16px;
    background-color: #fff;
    margin: 9px;
    padding: 6px;
}
.table{
    margin-top: 0.5rem;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar{
width: 7px;
height: 7px;
background-color: #F5F5F5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
border-radius: 10px;
background-color: #F5F5F5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb{
border-radius: 10px;
width: 7px;
box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
background-color: #c8c8c8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue